import { differenceInDays, differenceInMonths, format, formatDistanceToNow } from 'date-fns-jalali';
import { faIR } from 'date-fns-jalali/locale';

export const fromNow = (
  date: string | Date,
  timeAgoBasis: 'one-day' | 'one-month',
  formatString = 'dd MM yy',
) => {
  const now = new Date();
  const diff = timeAgoBasis === 'one-day' ? differenceInDays(now, date) : differenceInMonths(now, date);

  if (diff === 0) {
    return formatDistanceToNow(date, { locale: faIR, addSuffix: true });
  }

  return format(date, formatString, { locale: faIR });
};
